'use strict';

import { getUrlParam } from '../../functions';
import { getCommonAssets, getDictionary, getProp, getSettings, getSpecifications } from '../crm/crm-requests';
import { createOptionsCard } from './optionsCards';
import { setDataToApartment, setProjectSettings } from '../threejs/autoSelectionBoxes';
import {
	Buildings, components,
	isMobile,
	projectMode,
	resourcesFolder,
	settingsData,
	threeJsVariables,
	UIRoot,
} from '../../settings';
import { BuildingWithoutModel } from '../building/Building';
import { Object3D, WebGLRenderer } from 'three';
import { getVars } from '../customStyles/customStyles';
import { getLordIconColors } from '../../lordicon';
import { setInitialHtmlDirection } from '../components/langSwitcher/langSwitcher';
import { Loader } from '../threejs/loader/Loader';
import { Cloudflare } from '../api/Cloudflare';
import { createThreeJsEnvironment } from '../threejs/threejs-components';
import { Vantages } from '../components/vantage/Vantage';
import { DreamsPreloader } from '../components/preloader/DreamsPreloader';
import { PrivacyAndTerms } from '../menu/PrivacyAndTerms';
import { BaseElement } from '../interfaces/BaseElement';
import { addPoweredLogo } from '../components/poweredLogo/poweredLogo';
import { McID, McIDContactUs } from '../menu/contactUs/McID';
import { getContactsDataFromAPI } from '../menu/contactUs/contactUs';
import { ContactWidget } from '../components/chats/chats';
import { initForm } from '../components/form/form';

export class OptionsCardViewer {
	static active = false;

	constructor () {
		this.propId = getUrlParam('card');
	}

	async open() {
		if (!this.propId)
			return new Promise(resolve => resolve());

		const preloader = new DreamsPreloader(document.body)
			.absolute()
			.substrate()
			.blur();

		preloader.container.addStyle('left',0);
		preloader.container.addStyle('top',0);
		preloader.container.addStyle('zIndex',10);
		preloader.show();

		const response = await getProp(this.propId);

		if (response.data.length === 0) {
			preloader.remove();
			return new Promise(resolve => resolve());
		}

		const commonAssets = await getCommonAssets();
		settingsData.commonAssets = commonAssets.data;
		const settings = await getSettings();
		const dictionary = await getDictionary();
		OptionsCardViewer.active = true;

		const specifications = await getSpecifications();
		settingsData.specifications = specifications.data;

		createThreeJsEnvironment();

		let animateFn;

		function animate() {
			if (Vantages.isActive()) {
				Vantages.render();
			}
			animateFn = requestAnimationFrame(animate);
		}

		animate();

		function showCard () {
			const card = createOptionsCard({object: data, settings});
			card.classList.add('separate-card');

			if (config.features.apartments.cardPrice === false) {
				const priceBlock = card.querySelector('.options-card__price');
				priceBlock && priceBlock.classList.add('hidden');
			}

			const cardData = card.querySelector('.options-card__data');
			const bottomContainer = new BaseElement()
				.addClass('separate-card__bottom-container')
				.appendTo(cardData)
				.DOMElement;
			addPoweredLogo(bottomContainer);
			new PrivacyAndTerms({parent: bottomContainer});
			preloader.remove();
		}

		const loader = new Loader();
		const draco = loader.dracoLoader;
		draco.load(`${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/building/bundle.glb?v=${Cloudflare.version}`,(gltf) => {
			threeJsVariables.bundleConfig = gltf.scene.userData.config;
			showCard();
		},null,() => showCard());

		setProjectSettings(settings,dictionary);
		getVars(config.crmProjectSettings);
		getLordIconColors();
		setInitialHtmlDirection(config.crmProjectSettings);

		settingsData.allCrmData = response.data;
		const data = response.data[0];
		const obj = new Object3D();
		obj.name = data.engineId;
		setDataToApartment(obj,data);
		settingsData.lastClickedFlat = obj;

		if (isMobile) {
			getContactsDataFromAPI()
				.then((response) => {
					console.log(response);
					config.contactWidget = response.find(item => item.title === 'contactWidget').crmData;
					config.consolto = response.find(item => item.title === 'consolto').crmData;
					config.schedulerId = response.find(item => item.title === 'schedulerId').crmData;
					const mcId = new McID({}, 'mc-menu');
					const mcIdWrapper = new BaseElement()
						.addClass('additional-menu__item')
						.DOMElement;

					mcIdWrapper.appendChild(mcId.container);

					UIRoot.appendChild(mcIdWrapper);
					new McIDContactUs();
					components.contactWidget = new ContactWidget(UIRoot,false);
					components.contactWidget.create();
					McID.addNewButton(components.contactWidget.createOptionButton(),'mc-menu');
					initForm(UIRoot);
				});
		}

		projectMode.LiteMode = {
			isActive: () => false,
			resizeContainer: () => {}
		};

		const allBuildings = config.crmProjectSettings.buildings;
		allBuildings.forEach(building => {
			const buildingObject = new BuildingWithoutModel(building.buildingEngineId,settingsData.allCrmData,{data: config.crmProjectSettings});
			buildingObject.apartments = [obj];
			buildingObject.floorSliderNumbers = [data.floorNum, data.floorNum];
			Buildings.addBuilding(building.buildingEngineId,buildingObject);
			if (building.buildingEngineId === data.buildingEngineId) {
				Buildings.activateBuilding(building.buildingEngineId);
			}
		});

		return new Promise(resolve => {});
	}
}
